import React, { useMemo, useState } from "react";
import { convertCase } from "../../../../SharedFiles/Helper/utils";

import { useDispatch } from "react-redux";
import { GetsearchHistory } from "../../../../APIServices/SalesService/OrderHistory/HistoryThunk";
import { GetsearchInvoiceDeliver } from "../../../../APIServices/SalesService/InvoiceService/invoiceThunk";

const OptionToSearch = ({ tabValue, setInProgress, SetSearch}) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const PageType = sessionStorage.getItem("activeIcon");
  const tab = useMemo(() => {
    if (PageType === "history") {
      return tabValue === "SQ" ? "Quotation" : "Order";
    }
    return tabValue;
  }, [PageType, tabValue]);

  // const fieldMap = useMemo(
  //   () => ({
  //     order_No: "DocNum",
  //     customer_Name: "CardName",
  //     card_Name: "CardName",
  //     status: "DocStatus",
  //   }),
  //   []
  // );
  // const searchField = fieldMap[filterBy] || "";
  // const handleFilterChange = (e) => {
  //   setFilterBy(e.target.value);
  // };
  
  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchValue(searchValue);
    SetSearch(true);
    if (searchValue.trim() === "" ) {
      SetSearch(false);
      return;
    }
    setInProgress((prev) => ({ ...prev, searchHistory: true }));
    if (PageType === "history") {
      // dispatch(GetsearchHistory({ searchValue, searchField, tab }));
      dispatch(GetsearchHistory({ searchValue, tab }));
    } else  {
      dispatch(
        // GetsearchInvoiceDeliver({ searchValue, searchField, PageType, tab })
        GetsearchInvoiceDeliver({ searchValue, PageType, tab})
      );
    }
  };
  

  return (
    <>
      {/* <select
        value={filterBy}
        onChange={handleFilterChange}
        className="fiteroptionselect"
      >
        <option>select</option>
        <option value="order_No">Order No</option>
        <option value="card_Name">Customer Name</option>
        <option value="status">Status</option>
      </select> */}
      <input
        type="text"
        placeholder={convertCase(`Power search`)}
        value={searchValue}
        onChange={handleSearchChange}
        className="filter-input"
      />
    </>
  );
};

export default OptionToSearch;
